import { CheckCircle2, Info, XCircle } from 'lucide-react';
import { useToasts, dismiss } from '../../utils/toast';

/**
 * Toast 渲染宿主：在工作台根部渲染一次。
 * 状态存于 utils/toast.ts 的模块级 store（useToasts 订阅）。
 */
export default function ToastHost() {
  const list = useToasts();

  if (list.length === 0) return null;

  return (
    <div className="toast-host" role="status" aria-live="polite">
      {list.map((t) => (
        <div key={t.id} className={`toast toast--${t.kind} fade-in`} onClick={() => dismiss(t.id)}>
          <span className="toast__icon">
            {t.kind === 'success' ? (
              <CheckCircle2 size={15} />
            ) : t.kind === 'error' ? (
              <XCircle size={15} />
            ) : (
              <Info size={15} />
            )}
          </span>
          <span className="toast__text">{t.text}</span>
        </div>
      ))}
    </div>
  );
}
